import { TaskCommentComponent } from './admin/tasks-page/tasks/task-comment/task-comment.component';
import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { HomePageComponent } from './admin/home-page/home-page.component';
import { LoginPageComponent } from './site/login-page/login-page.component';
import { AuthGuard } from './shared/guards/auth.guards';
import { NotFoundPageComponent } from './site/not-found-page/not-found-page.component';
import { CurrenciesPageComponent } from './admin/currencies-page/currencies-page.component';
import { FeaturesPageComponent } from './admin/features-page/features-page.component';
import { CountriesPageComponent } from './admin/countries-page/countries-page.component';
import { CompaniesPageComponent } from './admin/companies-page/companies-page.component';
import { RolesPageComponent } from './admin/roles-page/roles-page.component';
import { LoggerPageComponent } from './admin/logger-page/logger-page.component';
import { SettingsPageComponent } from './admin/settings-page/settings-page.component';
import { UsersPageComponent } from './admin/users-page/users-page.component';
import { AccountPageComponent } from './admin/account-page/account-page.component';
import { ProductsPageComponent } from './admin/products-page/products-page.component';
import { CategoriesPageComponent } from './admin/categories-page/categories-page.component';
import { ExpensesPageComponent } from './admin/expenses-page/expenses-page.component';
import { WorkersPageComponent } from './admin/workers-page/workers-page.component';
import { ClientsPageComponent } from './admin/clients-page/clients-page.component';
import { TimeTracksPageComponent } from './admin/time-tracks-page/time-tracks-page.component';
import { TasksPageComponent } from './admin/tasks-page/tasks-page.component';
import { QuotesPageComponent } from './admin/quotes-page/quotes-page.component';
import { TaskRequestsPageComponent } from './admin/task-requests-page/task-requests-page.component';
import { AgentsPageComponent } from './admin/agents-page/agents-page.component';
import { DeliveryNotesPageComponent } from './admin/delivery-notes-page/delivery-notes-page.component';
import { BillingDocumentsPageComponent } from './admin/billing-documents-page/billing-documents-page.component';
import { ProjectsPageComponent } from './admin/projects-page/projects-page.component';
import { CalendarPageComponent } from './admin/calendar-page/calendar-page.component';
import { TasksStatusPageComponent } from './admin/tasks-status-page/tasks-status-page.component';
import { TasksCompletePageComponent } from './admin/tasks-complete-page/tasks-complete-page.component';
import { TasksCommentsPageComponent } from './admin/tasks-comments-page/tasks-comments-page.component';
import { VendorsPageComponent } from './admin/vendors-page/vendors-page.component';
import { ExpensesReportPageComponent } from './admin/expenses-report-page/expenses-report-page.component';
import { ReportsClientPageComponent } from './admin/reports-client-page/reports-client-page.component';
import { ReportsPageComponent } from './admin/reports-page/reports-page.component';

export const routes: Routes = [
  { path: '', redirectTo: 'site/login', pathMatch: 'full' },
  {
    path: 'site',
    component: SiteLayoutComponent,
    children: [
      { path: 'login', component: LoginPageComponent, title: 'Login Page' },
      // Otras rutas de 'site' pueden ir aquí.
    ]
  },
  {
    path: 'admin/:iid',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'home', component: HomePageComponent, title: 'Home Page' },

      { path: 'account', component: AccountPageComponent, canActivate: [AuthGuard] },

      { path: 'calendar', component: CalendarPageComponent, canActivate: [AuthGuard] },
      //{ path: 'calendar-by-worker', component: CalendarPageComponent, canActivate: [AuthGuard] }, //falta page
      { path: 'projects', component: ProjectsPageComponent, canActivate: [AuthGuard] },

      { path: 'agents', component: AgentsPageComponent, canActivate: [AuthGuard] },
      { path: 'task-requests', component: TaskRequestsPageComponent, canActivate: [AuthGuard] },
      { path: 'quotes', component: QuotesPageComponent, canActivate: [AuthGuard] },
      { path: 'tasks-list', component: TasksPageComponent, canActivate: [AuthGuard] },
      { path: 'tasks', component: TasksCompletePageComponent, canActivate: [AuthGuard] },
      { path: 'tasks-status', component: TasksStatusPageComponent, canActivate: [AuthGuard] },
      { path: 'delivery-notes', component: DeliveryNotesPageComponent, canActivate: [AuthGuard] },
      { path: 'billing-documents', component: BillingDocumentsPageComponent, canActivate: [AuthGuard] },

      { path: 'clients', component: ClientsPageComponent, canActivate: [AuthGuard] },
      { path: 'workers', component: WorkersPageComponent, canActivate: [AuthGuard] },
      { path: 'time-track', component: TimeTracksPageComponent, canActivate: [AuthGuard] },
      { path: 'tasks-comments', component: TasksCommentsPageComponent, canActivate: [AuthGuard] },

      { path: 'expenses-report', component: ExpensesReportPageComponent, canActivate: [AuthGuard] },
      { path: 'report-time-track-client', component: ReportsClientPageComponent, canActivate: [AuthGuard] },
      { path: 'report-time-track-worker', component: ReportsPageComponent, canActivate: [AuthGuard] },

      { path: 'products', component: ProductsPageComponent, canActivate: [AuthGuard] },
      { path: 'expenses', component: ExpensesPageComponent, canActivate: [AuthGuard] },
      { path: 'categories', component: CategoriesPageComponent, canActivate: [AuthGuard] },
      { path: 'vendors', component: VendorsPageComponent, canActivate: [AuthGuard] },
      { path: 'users', component: UsersPageComponent, canActivate: [AuthGuard] },
      { path: 'settings', component: SettingsPageComponent, canActivate: [AuthGuard] },
      { path: 'settings-company', component: HomePageComponent, canActivate: [AuthGuard] },
      { path: 'companies', component: CompaniesPageComponent, canActivate: [AuthGuard] },
      { path: 'companies-stats', component: CompaniesPageComponent, canActivate: [AuthGuard] },
      { path: 'roles', component: RolesPageComponent, canActivate: [AuthGuard] },
      { path: 'countries', component: CountriesPageComponent, canActivate: [AuthGuard] },
      { path: 'currencies', component: CurrenciesPageComponent, canActivate: [AuthGuard] },
      { path: 'features', component: FeaturesPageComponent, canActivate: [AuthGuard] },
      { path: 'logger', component: LoggerPageComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
